module.exports = __webpack_public_path__ + "img/bannerLabel3Red.286473c2.png";